<template>
    <div v-if="currencyOptions?.length" class="form-inline">
        <select
            :value="currency"
            class="form-control form-control-sm d-inline-block"
            @input="onCurrencyUpdate"
        >
            <option
                v-for="option in currencyOptions"
                :key="option.value"
                :selected="option == option.value"
                :value="option.value"
            >
                {{ option.label }}
            </option>
        </select>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    data() {
        return {};
    },
    computed: {
        ...mapGetters({
            customer: 'app/customer',
            currencyOptions: 'currencies/currencyOptions',
            currency: 'currencies/currency',
        }),
    },
    mounted() {
        this.getCurrencies();
    },
    methods: {
        ...mapActions({
            getCurrencies: 'currencies/getCurrencies',
            setCurrency: 'currencies/setCurrency',
            updateLoggedInCustomer: 'app/updateLoggedInCustomer',
        }),
        onCurrencyUpdate(event) {
            const currency = event.target.value;
            this.setCurrency(currency);
            if (this.customer) {
                this.updateLoggedInCustomer({ currency });
            }
        },
    },
}
</script>

<style lang="scss" scoped>
select {
    border: none;
    color: #0F4554 !important;
    font-size: 15px;;
    font-weight: normal;
}
</style>
